var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommonIconSnsInstagramLineWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.929 4.5c1.536 0 2.928.625 3.937 1.634A5.554 5.554 0 0 1 25.5 10.07v9.858a5.554 5.554 0 0 1-1.634 3.937A5.554 5.554 0 0 1 19.93 25.5H10.07a5.554 5.554 0 0 1-3.937-1.634A5.554 5.554 0 0 1 4.5 19.93V10.07c0-1.536.625-2.928 1.634-3.937A5.554 5.554 0 0 1 10.07 4.5z",
    stroke: "#ECE0CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z",
    stroke: "#ECE0CE",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 8A1.255 1.255 0 0 0 20 9.25c0 .329.134.651.367.884.232.232.555.366.883.366.33 0 .651-.134.884-.366a1.26 1.26 0 0 0 .366-.884c0-.33-.133-.652-.366-.884A1.255 1.255 0 0 0 21.25 8z",
    fill: "#ECE0CE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconSnsInstagramLineWhite);
export default __webpack_public_path__ + "static/media/common-icon-sns-instagram-line-white.e539fa9d1bf01f65fb5ed5380209d07d.svg";
export { ForwardRef as ReactComponent };